import React from 'react';
import { IIcon } from '..';
import cls from 'classnames';

export enum TagColors {
  SUCCESS,
  WARNING,
  INFO,
}

interface TagProps {
  text?: string;
  icon?: IIcon | React.ReactNode;
  color?: TagColors;
  className?: string;
}

// TODO: add treatment to render the marvelous set of Icons from FontTello

export const Tag: React.FC<TagProps> = ({ text, icon, color, className }): JSX.Element => {
  return (
    <div
      className={cls(
        'sk-tag',
        { 'sk-tag--success': color === TagColors.SUCCESS },
        { 'sk-tag--warning': color === TagColors.WARNING },
        { 'sk-tag--info': color === TagColors.INFO },
        className,
      )}
    >
      {icon && <span className="sk-tag__icon">{icon}</span>}
      <span>{text}</span>
    </div>
  );
};
